var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle217(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "199.10126658286583 767.6381723896044 16.399071595190037 16.49491315068758",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M211.5,775.92c-.03,2.41-1.98,4.3-4.36,4.21-2.38-.09-4.18-2.12-4.03-4.54.13-2.13,1.94-3.88,4.08-3.95,2.37-.07,4.34,1.88,4.31,4.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle217);
export default __webpack_public_path__ + "static/media/twinkle-2-17.d2609172756f77d5677c08b5c7016cd1.svg";
export { ForwardRef as ReactComponent };